import React, { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useQueryClient } from "@tanstack/react-query";

import { changeStatusTodo } from "../../sevices/apiTodo";
import { isAdmin } from "../../utils/constants";
import { useSelector } from "react-redux";
import CustomMenuItem from "../Menu/CustomMenuItem";
import { CustomButton } from "../Button/Button";
import useMutate from "../../hooks/useMutate";
import { invalidateCardQueries } from "../../utils/reactQuery/cards";
import useBoardIdByKey from "../../hooks/useBoardIdByKey";
const ChangeTodoStatus = React.memo(({
  todoStatus,
  cardId,
  owner_user_id,
  assigned_to_user_id,
  reporter,
  board_id,
  isBoardAdmins,
}) => {
  const [status, setStatus] = useState("");
  const queryClient = useQueryClient();
  const currentUser = useSelector((state) => state.users.logInUser);
  const {id} = useBoardIdByKey();

  // Permissions
  const checkOwnerOrAdmin = isAdmin() || currentUser?.user_id === owner_user_id || isBoardAdmins;
  const isAssignee = assigned_to_user_id === currentUser?.user_id;
  const isCreator = reporter === currentUser?.user_id;

  const steps = useMemo(() => {
    return [
      ...(checkOwnerOrAdmin || isAssignee || isCreator ? [{ name: "Open" }] : []),
      ...(checkOwnerOrAdmin || isCreator || isAssignee ? [{ name: "Completed", sx: { position: "sticky", bottom: "48px", backgroundColor: "#fff" } }] : []),
      ...(checkOwnerOrAdmin || isCreator ? [{ name: "Accepted", sx: { position: "sticky", bottom: "0px", backgroundColor: "#fff" } }] : []),
    ];
  }, [checkOwnerOrAdmin, isAssignee, isCreator]);

  useEffect(() => {
    setStatus(todoStatus);
  }, [todoStatus]);


  const { mutate: updateMutate } = useMutate(
    changeStatusTodo, 
    ["watching", "mineCards"], 
    () => {
      queryClient.invalidateQueries({
        queryKey: [`cards`, id],
      });
    }, 
    () => {
      invalidateCardQueries(queryClient, board_id, cardId);
    }, 
    () => {
      setStatus(todoStatus);
    }
  );

  const handleChange = (event) => {
    updateMutate({ card_id: cardId, todo_column: event.target.value });
    setStatus(event.target.value);
  };

  return (
    <Box>
      {steps.some((step) => step.name === status) ? (
        <FormControl size="small" className="card-status-dropdown-parent">
          <Select
            labelId="demo-simple-select-label"
            value={status}
            onChange={handleChange}
            className="card-status-dropdown"
          >
            {steps.map((el, index) => (
             <CustomMenuItem key={`${el?.name}-${index}`} className="uppercase" value={el.name}
             disabled={el.name === "Accepted" && todoStatus === "Open"}>    
                {el.name}
              </CustomMenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <div className="project-status d-flex justify-content-center align-items-center">
          <CustomButton className="project-status-button">{status}</CustomButton>
          <div className="project-status-icon"></div>
        </div>
      )}
    </Box>
  );
});

export default ChangeTodoStatus;
